import { Diamond, Clock, MapPin, Camera, MessageCircle, Calendar, Sparkles } from "lucide-react";
import { getLangFromWindow } from "@/utils/seoLang";

export const WA_PHONE = "905316224378";
export const WA_LINK = `https://wa.me/${WA_PHONE}`;
export const BADGE_ICONS = [Diamond, Clock, MapPin, Camera];
export const CONTACT_ICONS = [MessageCircle, Calendar, MapPin, Sparkles];

// Re-export so weddings components can resolve lang with the unified policy:
// URL ?lang → localStorage → navigator.language → "ru"
export function getLang(allowed = ["ru", "en"]) {
  return getLangFromWindow(allowed);
}

export function SectionHeading({ eyebrow, title, titleAccent, subtitle }) {
  return (
    <div className="text-center mb-10 sm:mb-14">
      <p className="text-[10px] sm:text-[11px] tracking-[0.3em] sm:tracking-[0.35em] text-[#B8966F] mb-3 sm:mb-4 font-light">{eyebrow}</p>
      <h2 className="text-3xl sm:text-4xl lg:text-5xl text-[#1F1815] leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}>
        {title} {titleAccent && <span className="italic text-[#8B6F47]">{titleAccent}</span>}
      </h2>
      {subtitle && <p className="text-sm sm:text-base text-[#6B5D4F] font-light mt-4 sm:mt-5 max-w-2xl mx-auto leading-relaxed px-2">{subtitle}</p>}
      <div className="w-12 sm:w-16 h-px bg-[#C9A87C] mx-auto mt-5 sm:mt-6" />
    </div>
  );
}
